/**
 * Cross-app theme seed — inline it as the FIRST body child, BEFORE next-themes
 * hydrates, via `<script dangerouslySetInnerHTML={{ __html: THEME_SEED }} />`.
 *
 * If the shared `owlcat-theme` cookie holds an explicit `light|dark` choice (set
 * by accounts or a sibling app on the parent domain), prime
 * `localStorage['theme']` (next-themes' default storageKey) AND toggle the
 * documentElement `dark` class to match, so next-themes hydrates in agreement
 * with no flash and no reset. No cookie → do nothing; next-themes' own inline
 * script keeps the system (no-flash) path.
 *
 * Byte-for-byte the string the fleet layouts previously inlined locally.
 */
export const THEME_SEED = `(function(){try{var m=document.cookie.match(/(?:^|; )owlcat-theme=(light|dark)/);if(m){var t=m[1];localStorage.setItem('theme',t);var e=document.documentElement;if(t==='dark')e.classList.add('dark');else e.classList.remove('dark');}}catch(e){}})();`;
